export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '新增',
    close: '关闭',
    search: '搜索',
    reset: '重置',
    loading: '加载中...',
    noData: '暂无数据',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '提示',
    required: '必填',
    optional: '可选',
    yes: '是',
    no: '否',
    ok: '确定',
    apply: '应用',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    refresh: '刷新',
    download: '下载',
    upload: '上传',
    fetchUserInfoFailed: '获取用户信息失败',
    view: '查看',
    actions: '操作',
    status: '状态',
    type: '类型',
    time: '时间',
    date: '日期',
    name: '名称',
    description: '描述',
    remarks: '备注',
    settings: '设置',
    all: '全部',
    total: '共',
    items: '条',
    page: '页',
    day: '天',
    second: '秒',
    and: '和',
    perPage: '条/页',
    running: '运行中',
    stopped: '已停止',
    starting: '启动中',
    stopping: '停止中',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    networkError: '网络错误',
    errorPage: {
      title: '错误',
      errorOccurred: '发生了错误',
      unknownError: '未知错误',
      goHome: '返回首页',
      goBack: '返回',
      errorDetails: '错误详情',
      paramParseError: '参数解析错误',
    },
    requestFailed: '请求失败',
    pleaseWait: '请稍候...',
    noPermission: '无权限',
    notLoggedIn: '请先登录',
    redirectToLogin: '跳转到登录页',
  },
  moduleMgmt: {
    title: '模块管理',
    totalModules: '总模块数',
    enabled: '已启用',
    disabled: '已禁用',
    viewDisabledModules: '查看禁用模块',
    moduleManagement: '模块管理',
    enableDisableManagement: '启用/禁用管理',
    refresh: '刷新',
    noModuleInfo: '暂无模块信息',
    moduleName: '模块名称',
    category: '分类',
    categoryFile: '文件',
    categoryServer: '服务器',
    categoryP2P: 'P2P',
    categoryProxy: '代理',
    categoryDNS: 'DNS',
    categoryDevice: '设备',
    status: '状态',
    dependency: '依赖',
    details: '详情',
    enable: '启用',
    disable: '禁用',
    moduleDetails: '模块详情',
    name: '名称',
    description: '描述',
    version: '版本',
    running: '运行中',
    notEnabled: '已禁用',
    noDependency: '无',
    dependsOn: '依赖',
    dependedBy: '依赖该模块',
    dependencySatisfied: '依赖满足',
    yes: '是',
    no: '否',
    close: '关闭',
    disabledModuleList: '禁用模块列表',
    noDisabledModules: '没有禁用的模块',
    error: '错误',
    action: '操作',
  },
  p2pClientSettings: {
    title: 'P2P设置',
    basicSettings: 'P2P基础设置',
    clientLabel: '客户端',
    viewLogs: '查看日志',
    stop: '停止',
    editConfig: '编辑配置',
    name: '名称',
    serverAddress: '服务器地址',
    secretKey: '密钥',
    secondKey: '第二密钥',
    enableRelay: '启用中继',
    enabled: '已启用',
    disabled: '已禁用',
    exportPort: '导出端口',
    status: '状态',
    nodeInfo: 'P2P节点信息',
    localNatType: '本地NAT类型',
    localConnectAddr: '本地连接地址',
    peerNatType: '对端NAT类型',
    peerAddr: '对端地址',
    peerStatus: '状态',
    portMapping: 'P2P端口映射',
    addMapping: '添加映射',
    stopAll: '全部停止',
    restartAll: '全部重启',
    loading: '加载中...',
    noMapping: '暂无端口映射配置',
    mappingName: '名称',
    localPort: '本地端口',
    peerIP: '对端IP',
    peerPort: '对端端口',
    protocol: '协议',
    operation: '操作',
    start: '启动',
    edit: '编辑',
    delete: '删除',
    addNewMapping: '添加端口映射',
    editMapping: '编辑端口映射',
    localPortPlaceholder: '1-65535',
    peerIpPlaceholder: '例如: 127.0.0.1',
    selectProtocol: '选择协议',
    cancel: '取消',
    save: '保存',
    editClientConfig: '编辑P2P客户端配置',
    clientNamePlaceholder: '客户端名称',
    secretKeyPlaceholder: '3-20个字符',
    optional: '可选',
    selectEnable: '选择',
    saveAndStart: '保存并启动',
    runningLogs: '运行日志',
    totalLogs: '共{count}条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    close: '关闭',
    noLogs: '暂无日志',
    confirmStopAll: '确定要停止所有映射吗？',
    confirmRestartAll: '确定要重启所有映射吗？',
    confirmDeleteMapping: '确定要删除映射"{name}"吗？',
    warning: '警告',
    confirm: '确认',
    mappingAdded: '映射已添加',
    mappingUpdated: '映射已更新',
    mappingDeleted: '映射已删除',
    mappingStarted: '映射已启动',
    mappingStopped: '映射已停止',
    mappingStoppedAll: '所有映射已停止',
    mappingRestartedAll: '所有映射已重启',
    saveFailed: '保存失败',
    operationFailed: '操作失败',
    namePlaceholder: '3-15个字符，只能是数字或字母',
    nameFormatError: '名称必须为3-15个字符，只能是数字或字母',
    portRangeError: '端口范围为1-65535',
    ipFormatError: 'IP地址格式不正确',
    pleaseSelectProtocol: '请选择协议',
    nameRequired: '请输入名称',
    secretKeyRequired: '请输入密钥',
    secretKeyFormatError: '密钥必须为3-20个字符，只能是数字或字母',
    localPortRequired: '请输入本地端口',
    peerIpRequired: '请输入对端IP地址',
    peerPortRequired: '请输入对端端口',
    portRequired: '请输入端口',
    ipRequired: '请输入IP地址',
    portProtocolRequired: '请输入端口和协议',
    clientConfigUpdated: '客户端配置已更新',
    fetchFailed: '获取数据失败',
    updateFailed: '更新失败',
    updateSuccess: '更新成功',
    stopFailed: '停止失败',
    stopSuccess: '停止成功',
    addFailed: '添加失败',
    addSuccess: '添加成功',
    startFailed: '启动失败',
    startSuccess: '启动成功',
    deleteFailed: '删除失败',
    deleteSuccess: '删除成功',
    stopAllFailed: '全部停止失败',
    stoppedAllSuccess: '所有映射已停止',
    restartAllFailed: '全部重启失败',
    restartedAllSuccess: '所有映射已重启',
    pleaseSelectServer: '请先选择服务器！',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    fetchLogsFailed: '获取日志失败',
    fetchLogsError: '获取日志失败',
    confirmClearLogs: '确定要清空所有P2P客户端日志吗？',
    clearLogsFailed: '清空日志失败',
    logsCleared: '日志已清空',
  },
  nav: {
    sysHome: '系统主页',
    transferServer: '中转服务器',
    distributionServer: '分发服务器',
    officialClient: '控制服务器',
    officialServer: '控制服务端',
    serverMapping: '端口映射',
    p2pSetting: 'P2P设置',
    p2pClient: 'P2P客户端',
    userLogin: '用户登录',
    userMgmt: '用户管理',
    fileMgmt: '文件管理',
    fileSetting: '文件配置',
    fileList: '文件列表',
    collectList: '收藏夹',
    shareLinkList: '分享夹',
    networkFileServices: '网络文件服务',
    mountMgmt: '挂载设置',
    ddnsSetting: 'DDNS全局设置',
    aliyunDdns: '阿里云DDNS设置',
    pubyunDdns: 'pubyun DDNS设置',
    nameyunDdns: 'nameCom DDNS设置',
    tencentcloudDdns: 'tencentcloud DDNS设置',
    cloudflareDdns: 'cloudflare DDNS设置',
    acmeMgmt: 'ACME证书管理',
    proxyMgmt: '正向代理',
    reverseProxy: '反向代理',
    fileSyncMgmt: '文件同步',
    deviceCenter: '设备中心',
    moduleMgmt: '模块管理',
    sysSetting: '系统设置',
    sysAbout: '关于系统',
    leftNav: '左侧导航',
    topNav: '顶部导航',
    logout: '退出登录',
    userManagement: '用户管理',
    userConfig: '用户配置',
    fileManagement: '文件管理',
    fileConfig: '文件配置',
    favorites: '收藏夹',
    shareFolder: '分享文件夹',
    networkFileService: '网络文件服务',
    fileSync: '文件同步',
    serverManagement: '服务器管理',
    p2pManagement: 'P2P管理',
    proxyManagement: '代理管理',
    forwardProxy: '正向代理',
    ddnsManagement: 'DDNS管理',
    namecomDdns: 'NameCom DDNS',
    acmeManagement: 'ACME证书管理',
    mountSettings: '挂载设置',
    moduleManagement: '模块管理',
    systemSettings: '系统设置',
    about: '关于',
    legacyEntry: '传统入口',
    loggedOut: '未登录',
    logoutButton: '退出按钮',
  },
  login: {
    title: '用户登录',
    username: '用户名',
    password: '密码',
    login: '登录',
    loggingIn: '登录中...',
    rememberMe: '记住登录状态',
    forgotPassword: '忘记密码',
    securePath: '安全路径',
    syncLogin: '自动登录',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    passwordError: '用户名或密码错误',
    userNotExist: '用户不存在',
    usernameEmpty: '用户名为空',
    passwordEmpty: '密码为空',
    autoLoginSuccess: '自动登录成功',
    networkError: '网络错误，请检查网络连接',
    requestError: '请求配置错误',
    defaultCredentials: '默认账户信息',
    defaultUsername: '用户名: admin',
    defaultPassword: '密码: tf12345678',
    changePasswordTip: '提示：这是默认账户。请立即通过"用户管理 -> 用户设置"更改用户名或密码',
    clickToViewTip: '点击查看默认账户信息',
    clickToView: '点击查看',
    viewTip: '查看',
    defaultAccountTip: '提示',
    resetPasswordTip: '请联系系统管理员重置密码',
    captchaError: '验证码错误',
    usernameLength: '用户名长度必须是1-20个字符',
    passwordLength: '密码长度必须是1-20个字符',
  },
  home: {
    welcome: '欢迎使用',
    overview: '概览',
    systemStatus: '系统状态',
    quickActions: '快捷操作',
    recentActivity: '最近活动',
    diskUsage: '磁盘使用',
    memoryUsage: '内存使用',
    cpuUsage: 'CPU使用',
    networkTraffic: '网络流量',
    onlineUsers: '在线用户',
    totalUsers: '总用户数',
    totalFiles: '总文件数',
    serviceStatus: '服务状态',
    uptime: '运行时间',
  },
  user: {
    title: '用户管理',
    addUser: '新增用户',
    editUser: '编辑用户',
    deleteUser: '删除用户',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    nickname: '昵称',
    email: '邮箱',
    telephone: '电话',
    role: '角色',
    roleStatus: '状态',
    remark: '备注',
    createTime: '注册时间',
    loginTime: '最后登录',
    superAdmin: '超级管理员',
    admin: '管理员',
    normalUser: '普通用户',
    active: '激活',
    inactive: '停用',
    passwordRequired: '请输入密码',
    passwordMinLength: '密码长度在 6 到 20 个字符',
    passwordMismatch: '两次输入的密码不一致',
    usernameRequired: '请输入用户名',
    usernameLength: '用户名长度需在 3-20 个字符之间',
    roleRequired: '请选择角色',
    addSuccess: '添加用户成功',
    editSuccess: '用户信息更新成功',
    deleteSuccess: '用户删除成功',
    deleteConfirm: '确定要删除用户吗？此操作不可撤销！',
    activate: '激活',
    deactivate: '停用',
    activated: '已激活',
    deactivated: '已停用',
    viewLogs: '查看日志',
    changeUsername: '改用户名',
    modifySuperAdmin: '修改超级管理员用户名',
    currentUsername: '当前用户名',
    newUsername: '新用户名',
    renameSuccess: '用户名修改成功，请重新登录',
    cannotDeleteSuperAdmin: '不能删除超级管理员',
    passwordEmptyHint: '留空表示不修改密码',
    fetchFailed: '获取用户信息失败',
    usernameSameAsCurrent: '新用户名不能与当前用户名相同',
    userDeactivated: '用户已停用',
    userActivated: '用户已激活',
    activateFailed: '激活用户失败',
    deactivateFailed: '停用用户失败',
    statusUpdateFailed: '更新用户状态失败',
    renameFailed: '更新用户名失败',
    userRenamed: '用户名修改成功，请重新登录',
  },
  file: {
    title: '文件管理',
    fileSetting: '文件配置',
    fileList: '文件列表',
    shareLink: '分享链接',
    myCollections: '我的收藏',
    fileName: '文件名',
    fileSize: '大小',
    fileType: '类型',
    filePath: '路径',
    modifiedTime: '修改时间',
    name: '名称',
    type: '类型',
    path: '路径',
    open: '打开',
    upload: '上传',
    properties: '属性',
    share: '分享',
    download: '下载',
    rename: '重命名',
    move: '移动',
    copy: '复制',
    paste: '粘贴',
    delete: '删除',
    newFolder: '新建文件夹',
    uploadFile: '上传文件',
    uploadFolder: '上传文件夹',
    refresh: '刷新',
    selectAll: '全选',
    deselectAll: '取消全选',
    inverseSelect: '反选',
    pathNavigation: '路径导航',
    fileOrFolder: '文件或文件夹',
    fileCount: '文件数',
    folderCount: '文件夹数',
    parentFolder: '上级文件夹',
    rootDirectory: '根目录',
    noFiles: '当前文件夹为空',
    folderModal: {
      currentPath: '当前路径',
      manualInputPath: '手动输入路径',
      enterPathHint: '请输入目录路径，输入后可直接点击确认',
      useThisPath: '使用此路径',
      afterInputHint: '输入后点击"使用此路径"或按回车键',
      emptyDirectory: '当前目录为空',
      selected: '已选择',
      parentFolder: '上一级',
    },
    confirmDelete: '确认删除',
    deleteSelected: '删除选中项',
    confirmDeleteMultiple: '确定要删除选中的 {count} 个项目吗？',
    renameTitle: '重命名',
    enterNewName: '请输入新名称',
    nameCannotBeEmpty: '名称不能为空',
    invalidFileName: '文件名包含非法字符',
    renameSuccess: '重命名成功',
    renameFailed: '重命名失败',
    shareLinkManagement: '分享链接管理',
    createShareLink: '创建分享链接',
    shareLinkUrl: '分享链接',
    shareLinkExpiry: '过期时间',
    shareLinkPassword: '提取码',
    copyLink: '复制链接',
    linkCopied: '链接已复制',
    neverExpiry: '永不过期',
    oneDay: '1天',
    sevenDays: '7天',
    thirtyDays: '30天',
    customExpiry: '自定义',
    shareLinkCreated: '分享链接创建成功',
    cancelShare: '取消分享',
    shareCancelled: '已取消分享',
    fileManagement: {
      webFileService: 'Web文件服务',
      networkFileService: '网络文件服务',
      onlineEditSetting: '在线编辑设置',
      onlineEditHint: 'OnlyOffice配置',
      officeAddress: '在线Office地址',
      officeIp: 'Office IP',
      operation: '操作',
      officeUrlPlaceholder: 'http://[ip:port]/web-apps/apps/api/documents/api.js',
      enable: '启用',
      update: '更新',
      close: '关闭',
      editableExtensions: '可编辑扩展名',
      readonlyExtensions: '只读扩展名',
      selectOrInputExtensions: '选择或输入扩展名',
      directoryList: '目录列表(通过用户管理创建)',
      viewLogs: '查看日志',
      refreshData: '刷新数据',
      username: '用户名',
      status: '状态',
      directory: '目录',
      readonly: '只读',
      delete: '删除',
      space: '空间',
      actions: '操作',
      activated: '已激活',
      notActivated: '未激活',
      addDirectory: '+ 添加目录',
      save: '保存',
      deactivate: '停用',
      activate: '激活',
      removeDirectory: '移除目录',
      yes: '是',
      no: '否',
      forbidden: '禁止',
      allowed: '允许',
      clickToApply: '点击保存以应用',
      processing: '处理中...',
      start: '启动',
      stop: '停止',
      running: '运行中',
      stopped: '已停止',
      parentFolder: '上级文件夹',
      manualInputPath: '手动输入路径(可选)',
      pleaseLoginFirst: '请先登录',
      autoRefreshEnabled: '自动刷新已启用(5秒)',
      autoRefreshDisabled: '自动刷新已禁用',
      networkError: '网络请求失败',
      fetchLogsFailed: '获取日志失败',
      unknownError: '未知错误',
      fetchLogsError: '获取日志失败:{error}',
      confirmClearLogs: '确定要清空所有文件管理日志吗？',
      clearLogsFailed: '清空日志失败',
      logsCleared: '日志已清空',
      noLogsToDownload: '没有可下载的日志',
      downloadLogsFailed: '下载日志失败:{error}',
      downloadLogsSuccess: '日志下载成功，共{count}条记录',
      fetchDataFailed: '获取数据失败',
      fetchSettingsFailed: '获取设置失败',
      pleaseLogin: '请登录',
      updateFileSettingFailed: '更新文件设置失败',
      fileSettingUpdated: '文件设置已更新',
      updateOfficeAttrFailed: '更新文件属性失败',
      officeAttrUpdated: '文件属性已更新',
      extensionsCannotBeEmpty: '可编辑和只读扩展名不能同时为空',
      operationFailed: '操作失败',
      webServiceStarted: 'Web服务已启动',
      webServiceStopped: 'Web服务已停止',
      stopUserFailed: '停止用户失败',
      userStopped: '用户{username}已停止',
      pleaseAddDirectoryFirst: '请至少添加一个目录',
      configSaveSuccess: '配置保存成功',
      saveFailed: '保存失败',
      saveConfigError: '保存失败:{error}',
      directoryRemoved: '目录{path}已移除，点击保存以应用',
      fetchDirectoryListFailed: '获取目录列表失败',
      pleaseInputDirectoryPath: '请输入目录路径',
      directorySelected: '已选目录:{path}，点击确认以保存',
      pleaseSelectDirectory: '请选择目录',
      directoryAlreadyExists: '目录已存在',
      directoryAdded: '目录{path}已添加',
      mobileUsername: '用户名',
      mobileStatus: '状态',
      mobileDirectory: '目录',
      mobileOperation: '操作',
      mobileReadonly: '只读',
      mobileDelete: '删除',
      mobileSpace: '空间',
      noLogRecords: '暂无日志记录',
    },
    newFile: '新建文件',
    newFilePlaceholder: '输入文件名(带扩展名)',
    newFolderPlaceholder: '输入文件夹名称',
    defaultNewFileName: '新建文件.txt',
    shareLinkList: '分享夹',
    linkPrefix: '链接前缀',
    modify: '修改',
    updateTime: '更新时间',
    expireTime: '过期时间',
    expired: '已过期',
    size: '大小',
    deleted: '已删除',
    validPeriod: '有效期',
    days: '天',
    password: '密码',
    canUpload: '可上传',
    sharer: '分享人',
    start: '启动',
    stop: '停止',
    edit: '编辑',
    copyLinkLabel: '复制链接',
    fileAttribute: '文件属性',
    validDays: '有效天数',
    none: '无',
    downloadPassword: '下载密码',
    operation: '操作',
    updateShareLink: '更新分享链接',
    validity: '有效期',
    longTerm: '永久',
    custom: '自定义',
    inputValidDays: '输入有效天数',
    leaveEmptyNoPassword: '留空则无需密码',
    uploadable: '可上传',
    yes: '是',
    no: '否',
    cancel: '取消',
    confirm: '确认',
    modifyShareLinkPrefix: '修改分享链接前缀',
    linkPrefixLabel: '链接前缀',
    inputShareLinkPrefix: '请输入分享链接前缀',
    prompt: '提示',
    objectDeleted: '对象已被删除',
    updateShareLinkPrefixFailed: '更新分享链接前缀失败',
    updateSuccess: '更新成功',
    passwordLengthInvalid: '密码长度必须为2-64个字符或为空',
    updateShareLinkFailed: '更新分享链接失败',
    fetchShareLinkFailed: '获取分享链接失败',
    pleaseLoginFirst: '请先登录',
    startShareLinkFailed: '启动分享链接失败',
    startSuccess: '启动成功',
    stopShareLinkFailed: '停止分享链接失败',
    stopSuccess: '停止成功',
    confirmDeleteShareLink: '确定要删除分享链接"{name}"吗？',
    deleteShareLinkFailed: '删除分享链接失败',
    deleteSuccess: '删除成功',
    linkMayBeOld: '此链接可能因在线编辑而过期。您可以通过在线预览下载最新内容',
    linkCopiedToClipboard: '链接已复制到剪贴板',
    copyFailed: '复制失败',
    pleaseManualCopy: '请手动复制',
    folder: '文件夹',
    image: '图片',
    wordDocument: 'Word文档',
    excelDocument: 'Excel文档',
    pptDocument: 'PPT文档',
    pdfDocument: 'PDF文档',
    textFile: '文本文件',
    compressedFile: '压缩文件',
    videoFile: '视频文件',
    audioFile: '音频文件',
    unknownFile: '文件',
    modifiedDate: '修改日期',
    allowUpload: '允许上传',
    collect: '收藏',
    cut: '剪切',
    imageLoadFailed: '图片加载失败',
    imageLoading: '图片加载中...',
    noSearchResults: '无搜索结果',
    searching: '搜索中...',
    tryOtherKeywords: '尝试其他关键词',
  },
  networkFile: {
    title: '网络文件服务',
    webdav: 'WebDAV文件服务(/tfdav)',
    webdavHttps: 'HTTPS WebDAV',
    webdavHttp: 'HTTP WebDAV',
    smb: 'SMB 文件共享服务',
    sftp: 'SFTP 服务',
    sftpComing: '即将支持',
    port: '端口',
    workgroup: '工作组',
    running: '运行中',
    stopped: '已停止',
    save: '保存',
    start: '启动',
    stop: '停止',
    startService: '启动服务',
    stopService: '停止服务',
    serviceStarted: '服务已启动',
    serviceStopped: '服务已停止',
    portSaved: '端口已保存',
    configSaved: '配置已保存',
    portAlreadyInUse: '端口已被占用',
    viewLogs: '查看日志',
    logTitle: '运行日志',
    webdavModule: 'WebDAV',
    smbModule: 'SMB',
    processing: '处理中...',
    totalLogs: '共 {count} 条日志',
    selectModule: '选择模块',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    operationFailed: '操作失败',
    saveFailed: '保存失败',
    httpsPortSaved: 'HTTPS端口已保存',
    httpPortSaved: 'HTTP端口已保存',
    smbPortSaved: 'SMB端口已保存',
    pleaseLoginFirst: '请先登录',
    networkFileServicesLog: '网络文件服务日志',
    close: '关闭',
  },
  mount: {
    title: '挂载管理',
    dependencyPackage: '依赖包',
    packageInfo: '包信息',
    systemInfo: '系统信息',
    status: '状态',
    installed: '已安装',
    notInstalled: '未安装',
    winfspDownload: '下载WinFSP',
    mountList: '挂载列表',
    viewLog: '查看日志',
    add: '添加',
    operationGuide: '操作指南',
    runningAsNonAdmin: '以非管理员运行',
    runningAsAdmin: '以管理员运行',
    runningAsNonAdminNote: '(注意:某些软件可能无法在挂载驱动器中运行)',
    noMountList: '暂无挂载列表',
    stop: '停止',
    open: '打开',
    log: '日志',
    start: '启动',
    edit: '编辑',
    delete: '删除',
    unmounted: '未命名',
    networkDrive: '网络驱动器',
    localDrive: '本地驱动器',
    addMount: '添加挂载',
    editMount: '编辑挂载',
    name: '名称',
    mountName: '挂载名称',
    mountPoint: '挂载点',
    webdavAddress: 'WebDAV地址',
    username: '用户名',
    password: '密码',
    method: '方式',
    mode: '模式',
    cancel: '取消',
    save: '保存',
    tfcenter: 'tfcenter',
    rclone: 'rclone',
    linuxOnlyRclone: '(Linux只能使用rclone方式)',
    leaveEmptyToKeepPassword: '留空则保持当前密码',
    logContent: '日志内容 - ',
    logSize: '日志大小:',
    refreshLog: '刷新日志',
    downloadLog: '下载日志',
    noLogContent: '暂无日志内容',
    close: '关闭',
    runningLog: '运行日志',
    totalLogs: '共{count}条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogRecords: '暂无日志记录',
    confirmClearLogs: '确定要清空所有WebDAV模块日志吗？',
    warning: '警告',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    confirmDeleteMount: '确定要删除挂载{name}吗？',
    pleaseLoginFirst: '请先登录',
    fetchLogFailed: '获取日志失败',
    fetchLogContentFailed: '获取日志内容失败:{error}',
    logRefreshed: '日志已刷新',
    noLogToDownload: '没有可下载的日志',
    logDownloadSuccess: '日志下载成功',
    logDownloadFailed: '日志下载失败:{error}',
    clearLogFailed: '清空日志失败:{error}',
    logsCleared: '日志已清空',
    noLogsToDownload: '没有可下载的日志',
    allLogsDownloadSuccess: '日志下载成功，共{count}条',
    logsDownloadFailed: '下载日志失败:{error}',
    addFailed: '添加失败',
    startFailed: '启动失败',
    updateFailed: '更新失败',
    deleteFailed: '删除失败',
    stopFailed: '停止失败',
    fetchMountListFailed: '获取挂载列表失败:{error}',
    cannotOpenFolderManually: '无法自动打开文件夹，请手动访问:',
    clickConfirmToCopyPath: '点击确认复制路径',
    copyCanceledOrFailed: '复制取消或失败',
    nameRequired: '名称必填',
    nameFormatError: '名称必须为3-15个字符，只能是数字或字母',
    mountPointRequired: '挂载点必填',
    webdavAddressRequired: 'WebDAV地址必填',
    usernameRequired: '用户名必填',
    passwordRequired: '密码必填',
    passwordLengthError: '密码必须为2-64个字符',
    pleaseSelectMethod: '请选择挂载方式',
    pleaseSelectMode: '请选择挂载模式',
    namePlaceholder: '3-15个字符，只能是数字或字母',
    mountNamePlaceholder: '挂载名称(可选)',
    mountPointPlaceholder: '挂载点',
    webdavAddressPlaceholder: 'WebDAV地址',
    usernamePlaceholder: '用户名',
    passwordPlaceholder: '密码',
    networkError: '网络请求失败',
    unknownError: '未知错误',
  },
  device: {
    title: '设备中心',
    deviceList: '设备列表',
    deviceName: '设备名称',
    deviceType: '设备类型',
    deviceStatus: '设备状态',
    online: '在线',
    offline: '离线',
    lastSeen: '最后在线',
    deviceId: '设备ID',
    addDevice: '添加设备',
    editDevice: '编辑设备',
    deleteDevice: '删除设备',
    deviceInfo: '设备信息',
    viewLogs: '查看日志',
    totalDevices: '设备总数',
    onlineDevices: '在线设备',
    offlineDevices: '离线设备',
    searchPlaceholder: '搜索设备名称或地址...',
    noDevices: '暂无设备',
    noDevicesHint: '点击"添加设备"按钮添加您的第一个设备',
    address: '地址',
    securePath: '安全路径',
    remark: '备注',
    index: '索引',
    connectDevice: '连接设备',
    edit: '编辑',
    delete: '删除',
    deviceNameRequired: '设备名称必填',
    deviceAddrRequired: '设备地址必填',
    addDeviceTitle: '添加设备',
    editDeviceTitle: '编辑设备',
    deviceNameLabel: '设备名称 *',
    deviceNamePlaceholder: '请输入设备名称',
    deviceAddrLabel: '设备地址 *',
    deviceAddrPlaceholder: '例如: http://192.168.1.100:8080',
    securePathLabel: '安全路径',
    securePathPlaceholder: '请输入安全路径(可选)',
    remarkLabel: '备注',
    remarkPlaceholder: '请输入设备备注(可选)',
    cancel: '取消',
    saving: '保存中...',
    updateDevice: '更新设备',
    addDeviceAction: '添加设备',
    confirmDelete: '确认删除',
    confirmDeleteMsg: '确定要删除设备"{name}"吗？',
    operationUndone: '此操作无法撤销！',
    deleting: '删除中...',
    confirmDeleteAction: '确认删除',
    operationLogs: '操作日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    totalLogs: '共{count}条日志',
    downloading: '下载中...',
    downloadAllLogs: '📥 下载所有日志',
    refreshing: '刷新中...',
    refreshNow: '🔄 立即刷新',
    clearing: '清空中...',
    clearLogs: '🗑️ 清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
    logsCleared: '日志已清空',
    logsClearFailed: '清空日志失败:{error}',
    fetchLogsFailed: '获取日志失败',
    noLogsToDownload: '没有可下载的日志',
    logsDownloadSuccess: '日志下载成功，共{count}条',
    logsDownloadFailed: '下载日志失败:{error}',
    loginRequired: '请先登录',
    loginRequiredRedirect: '请先登录',
    networkError: '网络请求失败',
    fetchDeviceListFailed: '获取设备列表失败',
    fetchDeviceListFailedRetry: '获取设备列表失败，请检查网络连接',
    saveDeviceFailed: '保存设备失败',
    saveDeviceFailedRetry: '保存设备失败，请检查网络连接',
    deviceUpdateSuccess: '设备更新成功',
    deviceAddSuccess: '设备添加成功',
    deviceUpdateFailed: '设备更新失败',
    deviceAddFailed: '设备添加失败',
    deviceDeleteSuccess: '设备删除成功',
    deviceDeleteFailed: '设备删除失败',
    deviceDeleteFailedRetry: '设备删除失败，请检查网络连接',
    deviceAddrEmpty: '设备地址不能为空',
    popupBlocked: '弹出窗口可能被浏览器阻止，请检查浏览器设置或尝试手动复制地址',
    addressCopied: '地址已复制到剪贴板:{address}',
    copyAddressFailed: '复制地址失败',
    openingDevicePage: '正在打开设备连接页面...',
    openDevicePageFailed: '打开设备页面失败:{error}',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    clearLogsConfirm: '确定要清空所有设备中心日志吗？',
    logsPerPage: '{count}条/页',
    selectLogSize: '选择日志大小',
    subtitle: '管理所有已连接设备的信息',
  },
  mapping: {
    title: '端口映射',
    addMapping: '添加映射',
    editMapping: '编辑映射',
    deleteMapping: '删除映射',
    internalPort: '内部端口',
    externalPort: '外部端口',
    protocol: '协议',
    tcp: 'TCP',
    udp: 'UDP',
    both: 'TCP/UDP',
    mappingStatus: '映射状态',
    enabled: '已启用',
    disabled: '已禁用',
    enable: '启用',
    disable: '禁用',
    enableSuccess: '映射已启用',
    disableSuccess: '映射已禁用',
  },
  tunnel: {
    title: '隧道管理',
    addTunnel: '添加隧道',
    editTunnel: '编辑隧道',
    deleteTunnel: '删除隧道',
    tunnelName: '隧道名称',
    tunnelType: '隧道类型',
    tunnelStatus: '隧道状态',
    localPort: '本地端口',
    remotePort: '远程端口',
    tunnelServer: '隧道服务器',
    connected: '已连接',
    disconnected: '已断开',
    connect: '连接',
    disconnect: '断开',
    connectSuccess: '隧道连接成功',
    disconnectSuccess: '隧道已断开',
  },
  homePage: {
    systemMonitorPanel: '系统监控面板',
    lastUpdate: '最后更新',
    refreshing: '刷新中...',
    manualRefresh: '手动刷新',
    viewLogs: '查看日志',
    systemInfo: '系统信息',
    hostName: '主机名称',
    cpuUsage: 'CPU使用率',
    memoryUsage: '内存使用',
    networkSpeed: '网络速度',
    systemTime: '系统时间',
    disk: '磁盘',
    softwareInfo: '软件信息',
    softwareVersion: '软件版本',
    cpuUsageShort: 'CPU占用',
    memoryUsageShort: '内存占用',
    goroutineCount: '协程数量',
    startTime: '启动时间',
    runningTime: '运行时间',
    runningLogs: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    confirmClearLogs: '确定要清空所有系统监控日志吗？',
    logsCleared: '日志已清空',
    noLogsToDownload: '暂无日志可下载',
    downloadSuccess: '日志下载成功，共 {count} 条记录',
    pleaseLoginFirst: '请先登录',
    fetchInfoFailed: '获取首页信息失败',
    networkError: '网络错误',
    clearError: '清空日志失败',
    downloadError: '下载日志失败',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    close: '关闭',
  },
  dns: {
    title: 'DNS管理',
    addDns: '添加DNS',
    editDns: '编辑DNS',
    deleteDns: '删除DNS',
    dnsProvider: 'DNS服务商',
    domain: '域名',
    recordType: '记录类型',
    recordValue: '记录值',
    ttl: 'TTL',
    dnsStatus: '状态',
    enabled: '已启用',
    disabled: '已禁用',
    enable: '启用',
    disable: '禁用',
    aliDns: '阿里云DNS',
    cloudflare: 'Cloudflare',
    tencentCloud: '腾讯云DNS',
    nameYun: '趣域网DNS',
    puYun: '派博DNS',
    accessKey: 'AccessKey',
    secretKey: 'SecretKey',
  },
  ddnsSetting: {
    title: '基础设置',
    basicSettings: '基础设置',
    publicIpCheckCycle: '公网地址检测周期',
    cycle: '检测周期',
    checkCycle: '检测周期',
    seconds: '秒',
    startService: '启动',
    stopService: '停止',
    edit: '编辑',
    status: '状态',
    running: '运行中',
    stopped: '已停止',
    modifyCheckCycle: '修改检测周期',
    inputCheckCycle: '请输入1-99999之间的整数',
    save: '保存',
    cancel: '取消',
    confirmStart: '确定要启动检测服务吗?',
    confirmStop: '确定要停止检测服务吗?',
    serviceStarted: '检测服务已启动',
    serviceStopped: '检测服务已停止',
    startFailed: '启动失败',
    stopFailed: '停止失败',
    fetchFailed: '获取数据失败',
    getSettingsFailed: '获取设置失败',
    updateFailed: '更新失败',
    updateSuccess: '更新成功',
  },
  ddns: {
    title: '动态DNS',
    addDdns: '添加DDNS',
    editDdns: '编辑DDNS',
    deleteDdns: '删除DDNS',
    domain: '域名',
    ipAddress: 'IP地址',
    lastUpdate: '最后更新',
    updateInterval: '更新间隔',
    updateNow: '立即更新',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    autoUpdate: '自动更新',
    aliyunAccessKey: '阿里云AccessKey',
    editKey: '编辑密钥',
    accessKeyId: 'AccessKey ID',
    accessKeySecret: 'AccessKey Secret',
    notConfigured: '未配置',
    ddnsList: 'DDNS列表',
    serviceEnabled: '服务已启用',
    serviceDisabled: '服务已禁用',
    viewLogs: '查看日志',
    addRecord: '添加记录',
    noDdnsRecords: '暂无DDNS记录',
    name: '名称',
    prefix: '前缀',
    domainName: '域名',
    type: '类型',
    ipType: 'IP获取方式',
    mappedIp: '映射IP',
    backupIp: '备用IP',
    status: '状态',
    actions: '操作',
    deactivate: '停用',
    activate: '启用',
    delete: '删除',
    edit: '编辑',
    editAliyunAccessKey: '编辑阿里云AccessKey',
    inputAccessKeyId: '请输入阿里云AccessKey ID',
    inputAccessKeySecret: '请输入阿里云AccessKey Secret',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A记录)',
    ipv6Record: 'IPv6 (AAAA记录)',
    autoGet: '自动获取',
    custom: '自定义',
    saveKey: '保存密钥',
    editDnsRecord: '编辑DNS记录',
    addDnsRecord: '添加DNS记录',
    save: '保存',
    update: '更新',
    operationLogs: '操作日志',
    totalLogs: '共{count}条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogRecords: '暂无日志记录',
    close: '关闭',
    recordName: '记录名称',
    inputRecordName: '请输入记录名称',
    recordPrefix: '记录前缀',
    inputPrefix: '例如: www, @, *',
    inputDomain: '例如: example.com',
    recordType: '记录类型',
    selectRecordType: '请选择记录类型',
    selectIpMethod: '请选择IP获取方式',
    inputIpAddress: '请输入IP地址',
    autoGetting: '自动获取中...',
    backupIpAddress: '备用IP地址',
    inputBackupIp: '请输入备用IP地址(可选)',
    confirmDeleteDns: '确定要删除此DNS记录吗？',
    confirmClearLogs: '确定要清空所有阿里云DDNS日志吗？',
    confirm: '确认',
    cancel: '取消',
    networkError: '网络请求失败',
    saveFailed: '保存失败',
    aliyunKeySaveSuccess: '阿里云密钥保存成功',
    aliyunKeySaveFailed: '阿里云密钥保存失败',
    dnsRecordSaveSuccess: 'DNS记录保存成功',
    dnsRecordSaveFailed: 'DNS记录保存失败',
    dnsRecordActivateSuccess: 'DNS记录已启用',
    dnsRecordActivateFailed: 'DNS记录启用失败',
    dnsRecordDeactivateSuccess: 'DNS记录已停用',
    dnsRecordDeactivateFailed: 'DNS记录停用失败',
    dnsRecordDeleteSuccess: 'DNS记录删除成功',
    dnsRecordDeleteFailed: 'DNS记录删除失败',
    autoRefreshEnabled: '自动刷新已启用(5秒间隔)',
    autoRefreshDisabled: '自动刷新已禁用',
    getLogsFailed: '获取日志失败',
    logsCleared: '日志已清空',
    logsClearFailed: '日志清空失败',
    noLogsToDownload: '没有可下载的日志',
    logsDownloadSuccess: '日志下载成功，共{count}条',
    logsDownloadFailed: '日志下载失败',
    getDataFailed: '获取数据失败',
    loginRequired: '请先登录',
    invalidIpv4: '请输入有效的IPv4地址',
    invalidIpv6: '请输入有效的IPv6地址',
    invalidRecordName: '名称只能包含字母、数字、下划线和连字符',
    invalidDomain: '请输入有效的域名',
    unknownStatus: '未知状态',
    activeSuccess: '成功',
    activateSuccess: '激活成功',
    activeFailed: '失败',
    activeError: '错误',
    inactive: '未启用',
    closed: '已关闭',
    multipleMappings: '存在多个映射',
    tencentAccessKey: '腾讯云AccessKey',
    tencentSecretId: 'SecretId',
    tencentSecretKey: 'SecretKey',
    secretId: 'SecretId',
    secretKey: 'SecretKey',
    editTencentAccessKey: '编辑腾讯云AccessKey',
    inputSecretId: '请输入SecretId',
    inputSecretKey: '请输入SecretKey',
    tencentKeySaveSuccess: '腾讯云密钥保存成功',
    tencentKeySaveFailed: '腾讯云密钥保存失败',
    dnsRecordTencentSaveSuccess: 'DNS记录保存成功',
    dnsRecordTencentSaveFailed: 'DNS记录保存失败',
    dnsRecordDeleteConfirm: '确定要删除此DNS记录吗？',
    dnsRecordDeleteTencentSuccess: 'DNS记录删除成功',
    dnsRecordDeleteTencentFailed: 'DNS记录删除失败',
    confirmClearTencentLogs: '确定要清空所有腾讯云DDNS日志吗？',
    globalDisabled: '全局已禁用',
    refreshIntervalSeconds: '(5秒)',
    tencentcloudLogsDownloadSuccess: '日志下载成功，共{count}条',
  },
  proxy: {
    title: '代理服务',
    httpProxy: 'HTTP代理',
    socks5Proxy: 'SOCKS5代理',
    proxyPort: '代理端口',
    proxyStatus: '代理状态',
    running: '运行中',
    stopped: '已停止',
    start: '启动',
    stop: '停止',
    startProxy: '启动代理',
    stopProxy: '停止代理',
    proxyStarted: '代理已启动',
    proxyStopped: '代理已停止',
  },
  fileSync: {
    title: '同步服务(单向同步)',
    globalSyncService: '同步服务(单向同步)',
    wifiSyncService: '仅WiFi同步(当前网络:{network})',
    enabled: '已启用',
    disabled: '已禁用',
    opening: '处理中...',
    open: '开启',
    close: '关闭',
    closeService: '关闭服务',
    openService: '开启服务',
    closeWiFiSync: '关闭WiFi同步',
    openWiFiSync: '开启WiFi同步',
    syncList: '同步列表',
    viewLogs: '查看日志',
    addTask: '添加任务',
    name: '名称',
    localPath: '本地路径',
    remoteAddr: '远程地址',
    remotePath: '远程路径',
    remoteUsername: '远程用户名',
    scanPeriod: '扫描周期(秒)',
    syncMethod: '同步方式',
    status: '状态',
    operation: '操作',
    stop: '停止',
    start: '启动',
    edit: '编辑',
    delete: '删除',
    currentNetwork: '当前网络',
    networkLabel: '当前网络:',
    noTasks: '暂无同步任务',
    addNewTask: '添加任务',
    editTask: '编辑任务',
    taskName: '任务名称',
    selectLocalPath: '请选择本地路径',
    enterRemoteAddr: '请输入远程地址',
    enterRemotePath: '请输入远程路径',
    enterUsername: '请输入用户名',
    enterPassword: '请输入密码',
    enterScanPeriod: '请输入扫描周期(秒)',
    selectSyncMethod: '请选择同步方式',
    save: '保存',
    cancel: '取消',
    syncOnStart: '启动时同步',
    deleteConfirm: '确定要删除此任务吗？',
    warning: '警告',
    confirm: '确认',
    taskAdded: '任务已添加',
    taskUpdated: '任务已更新',
    taskDeleted: '任务已删除',
    taskStarted: '任务已启动',
    taskStopped: '任务已停止',
    operationFailed: '操作失败',
    addFailed: '添加失败',
    updateFailed: '更新失败',
    deleteFailed: '删除失败',
    startFailed: '启动失败',
    stopFailed: '停止失败',
    runningLogs: '运行日志',
    totalLogs: '共{count}条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志',
    confirmClearLogs: '确定要清空所有同步日志吗？',
    logsCleared: '日志已清空',
    clearFailed: '清空日志失败',
    downloadFailed: '下载日志失败',
    noLogsToDownload: '没有可下载的日志',
    downloadSuccess: '日志下载成功，共{count}条',
    syncEnabled: '同步已启用',
    syncDisabled: '同步已禁用',
    wifiSyncEnabled: 'WiFi同步已启用',
    wifiSyncDisabled: 'WiFi同步已禁用',
    closeWiFiSyncService: '关闭仅WiFi同步',
    openWiFiSyncService: '开启仅WiFi同步',
    closeServiceButton: '关闭服务',
    openServiceButton: '开启服务',
    clickToViewNetwork: '点击查看网络',
    network: '网络',
    viewLogsButton: '查看日志',
    addTaskButton: '添加任务',
    runningStatus: '运行中',
    stoppedStatus: '已停止',
    taskNamePlaceholder: '3-15个字符，只能是字母和数字',
    localPathPlaceholder: '请选择本地路径',
    remoteAddrPlaceholder: '例如: 192.168.1.100:8080',
    remotePathPlaceholder: '远程路径',
    usernamePlaceholder: '用户名',
    remotePassword: '远程密码',
    leaveEmptyToKeep: '留空则保持当前密码',
    scanPeriodPlaceholder: '60',
    select: '选择',
    show: '显示',
    hide: '隐藏',
    add: '添加',
    parentFolder: '← 上级文件夹',
    parentFolderMobile: '← 返回',
    currentPath: '当前路径',
    manualInputPath: '手动输入路径(可选)',
    manualInputPathMobile: '手动输入路径',
    enterDirectoryPath: '请输入目录路径',
    emptyDirectory: '当前目录为空',
    selected: '已选择',
    downloading: '下载中...',
    refreshing: '刷新中...',
    clearing: '清空中...',
    perPage: '/页',
    syncLogs: '文件同步日志',
    totalLogsMobile: '共{count}条日志',
    confirmDeleteTask: '确定要删除{name}吗？',
    deleteSuccess: '删除成功',
    addTaskFailed: '添加任务失败',
    updateTaskFailed: '更新任务失败',
    startTaskFailed: '启动任务失败',
    stopTaskFailed: '停止任务失败',
    fetchDataFailed: '获取数据失败',
    fetchFoldersFailed: '获取文件夹列表失败',
    fetchLogsFailed: '获取日志失败',
    fetchLogsFailedDetail: '获取日志失败:{error}',
    networkError: '网络错误',
    unknownError: '未知错误',
    clearLogsFailed: '清空日志失败',
    clearLogsFailedDetail: '清空日志失败:{error}',
    directorySelected: '已选目录:{path}，请点击确认保存',
    pleaseSelectDirectory: '请选择或输入目录路径',
    autoRefreshEnabled: '自动刷新已启用(5秒)',
    autoRefreshDisabled: '自动刷新已禁用',
    downloadLogsFailed: '下载日志失败',
    downloadLogsFailedDetail: '下载日志失败:{error}',
    addSync: '添加同步',
    editSync: '编辑同步',
    deleteSync: '删除同步',
    syncTask: '同步任务',
    syncMode: '同步模式',
    sourcePath: '源路径',
    targetPath: '目标路径',
    syncDirection: '同步方向',
    upload: '上传',
    download: '下载',
    bidirectional: '双向',
    syncStatus: '同步状态',
    syncing: '同步中',
    synced: '已同步',
    error: '错误',
    startSync: '开始同步',
    pauseSync: '暂停同步',
    syncNow: '立即同步',
    lastSync: '上次同步',
    nextSync: '下次同步',
    syncSuccess: '同步成功',
    syncFailed: '同步失败',
  },
  p2p: {
    title: 'P2P连接',
    addPeer: '添加对等点',
    editPeer: '编辑对等点',
    deletePeer: '删除对等点',
    peerId: '对等点ID',
    peerName: '对等点名称',
    peerAddress: '对等点地址',
    connectionStatus: '连接状态',
    connected: '已连接',
    connecting: '连接中',
    disconnected: '已断开',
    connect: '连接',
    disconnect: '断开',
    peerInfo: '对等点信息',
  },
  pubyunDdns: {
    configTitle: 'PubYun(3322)配置',
    editConfig: '编辑配置',
    username: '用户名',
    password: '密码',
    notConfigured: '未配置',
    ddnsList: 'DDNS列表',
    serviceEnabled: '服务已启用',
    serviceDisabled: '服务已禁用',
    viewLogs: '查看日志',
    addRecord: '新增记录',
    noRecords: '暂无DDNS记录',
    name: '名称',
    domain: '域名',
    type: '类型',
    ipType: '获取IP方式',
    mappedIp: '映射IP',
    status: '状态',
    actions: '操作',
    update: '更新',
    delete: '删除',
    cancel: '取消',
    saveConfig: '保存配置',
    editPubyunConfig: '编辑PubYun配置',
    inputUsername: '请输入PubYun用户名',
    inputPassword: '请输入PubYun密码',
    editDnsRecord: '编辑DNS记录',
    addDnsRecord: '新增DNS记录',
    recordName: '记录名称',
    inputRecordName: '请输入记录名称',
    inputDomain: '例如: example.3322.org',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A记录)',
    ipv6Record: 'IPv6 (AAAA记录)',
    autoGet: '自动获取',
    custom: '自定义',
    autoGetting: '自动获取中...',
    title: '标题',
    logTitle: '运行日志',
    alertUpdateInterval: '注意：两次更新请求间隔时间不能短于1分钟（收费用户不能短于15秒），如果连续3次以上频繁请求，该域名会被系统自动封堵。',
  },
  nameyunDdns: {
    configTitle: 'NameYun配置',
    editConfig: '编辑配置',
    username: '用户名',
    password: 'Token',
    notConfigured: '未配置',
    ddnsList: 'DDNS列表',
    serviceEnabled: '服务已启用',
    serviceDisabled: '服务已禁用',
    viewLogs: '查看日志',
    addRecord: '新增记录',
    noRecords: '暂无DDNS记录',
    name: '名称',
    prefix: '前缀',
    domain: '域名',
    type: '类型',
    ipTypeGet: '获取IP方式',
    mappedIp: '映射IP',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    update: '更新',
    delete: '删除',
    cancel: '取消',
    saveConfig: '保存配置',
    editNameyunConfig: '编辑NameYun配置',
    inputUsername: '请输入NameYun用户名',
    inputToken: '请输入NameYun Token',
    editDnsRecord: '编辑DNS记录',
    addDnsRecord: '新增DNS记录',
    recordName: '记录名称',
    inputRecordName: '请输入记录名称',
    inputPrefix: '例如: www, @, *',
    inputDomain: '例如: example.com',
    recordType: '记录类型',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A记录)',
    ipv6Record: 'IPv6 (AAAA记录)',
    autoGet: '自动获取',
    custom: '自定义',
    ipAddress: 'IP地址',
    autoGetting: '自动获取中...',
    inputIpAddress: '请输入IP地址',
    globalDisabled: '全局关闭',
    logTitle: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
  },
  cloudflareDdns: {
    configTitle: 'Cloudflare 配置',
    editConfig: '编辑配置',
    configKeyId: 'ZoneID',
    configToken: 'Token',
    notConfigured: '未配置',
    ddnsList: 'DDNS列表',
    serviceEnabled: '服务已启用',
    serviceDisabled: '服务已禁用',
    viewLogs: '查看日志',
    addRecord: '新增记录',
    noRecords: '暂无DDNS记录',
    name: '名称',
    prefix: '前缀',
    domain: '域名',
    type: '类型',
    ipTypeGet: '获取IP方式',
    mappedIp: '映射IP',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    update: '更新',
    delete: '删除',
    cancel: '取消',
    saveConfig: '保存配置',
    editCloudflareConfig: '编辑Cloudflare配置',
    inputZoneId: '请输入ZoneID',
    inputToken: '请输入Token',
    editDnsRecord: '编辑DNS记录',
    addDnsRecord: '新增DNS记录',
    recordName: '记录名称',
    inputRecordName: '请输入记录名称',
    inputPrefix: '例如: www, @, *',
    inputDomain: '例如: example.com',
    recordType: '记录类型',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A记录)',
    ipv6Record: 'IPv6 (AAAA记录)',
    autoGet: '自动获取',
    custom: '自定义',
    ipAddress: 'IP地址',
    autoGetting: '自动获取中...',
    inputIpAddress: '请输入IP地址',
    globalDisabled: '全局关闭',
    logTitle: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
  },
  acmeMgmt: {
    title: 'ACME 证书配置',
    subtitle: '证书管理',
    certMgmt: '证书管理',
    viewLogs: '查看日志',
    addConfig: '新增配置',
    noCerts: '暂无证书配置',
    name: '名称',
    mainDomain: '主域名',
    subdomains: '子域名',
    provider: '提供商',
    challengeMethod: '验证方式',
    autoRenew: '自动续期',
    certStatus: '证书状态',
    notApplied: '未申请',
    actions: '操作',
    apply: '申请',
    edit: '编辑',
    delete: '删除',
    editCertConfig: '编辑证书配置',
    addCertConfig: '新增证书配置',
    configName: '配置名称',
    inputConfigName: '请输入唯一标识名称',
    mainDomainLabel: '主域名',
    inputMainDomain: 'example.com',
    subdomainsLabel: '子域名',
    inputSubdomains: '请输入子域名，支持通配符如 *.example.com',
    dnsProvider: 'DNS提供商',
    aliyun: '阿里云',
    tencent: '腾讯云',
    challengeType: '验证方式',
    dnsChallenge: 'DNS验证',
    autoRenewal: '自动续期',
    enabled: '已开启',
    disabled: '已关闭',
    hintAutoRenew: '(证书小于30天自动续约90天)',
    update: '更新',
    save: '保存',
    cancel: '取消',
    forceRequestTitle: '申请证书',
    forceRequestWarning: '当前证书有效期大于30天，是否强制重新申请？',
    forceRequestHint: '该申请将删除旧证书并生成新证书',
    forceApply: '强制申请',
    logTitle: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
  },
  acme: {
    title: 'ACME证书',
    domain: '域名',
    certificate: '证书',
    privateKey: '私钥',
    issuer: '颁发者',
    validFrom: '生效时间',
    validTo: '过期时间',
    autoRenew: '自动续期',
    renew: '续期',
    renewSuccess: '续期成功',
    renewFailed: '续期失败',
    issueCert: '签发证书',
    deleteCert: '删除证书',
  },
  system: {
    title: '系统设置',
    basicSettings: '基础设置',
    securitySettings: '安全设置',
    networkSettings: '网络设置',
    backupSettings: '备份设置',
    about: '关于',
    productName: '产品名称',
    version: '版本',
    currentVersion: '当前版本',
    newVersion: '新版本',
    checkUpdate: '检查更新',
    noUpdate: '已是最新版本',
    downloadUpdate: '下载更新',
    installUpdate: '安装更新',
    systemInfo: '系统信息',
    platform: '平台',
    architecture: '架构',
    operatingSystem: '操作系统',
    webPort: 'Web端口',
    webHttpsPort: 'Web HTTPS端口',
    webdavPort: 'WebDAV端口',
    logLevel: '日志级别',
    debug: '调试',
    info: '信息',
    warn: '警告',
    error: '错误',
    saveSettings: '保存设置',
    resetSettings: '重置设置',
    settingsSaved: '设置已保存',
    settingsReset: '设置已重置',
    backupNow: '立即备份',
    restoreBackup: '恢复备份',
    backupSuccess: '备份成功',
    restoreSuccess: '恢复成功',
    selectBackupFile: '选择备份文件',
    loginRedirectPage: '登录跳转页面',
    systemLog: '系统日志',
    edit: '编辑',
    webSettings: '网页设置(需重启)',
    httpPort: 'HTTP端口',
    httpStatus: 'HTTP状态',
    httpsPort: 'HTTPS端口',
    httpsStatus: 'HTTPS状态',
    certPath: '证书路径',
    webdavSuffix: 'WebDAV后缀',
    on: '开',
    off: '关',
    noPasswordLogin: '无密码登录(127.0.0.1)',
    currentStatus: '当前状态',
    logSettings: '日志设置',
    logDays: '日志天数',
    cacheSettings: '缓存设置',
    cacheAddress: '缓存地址',
    cacheTime: '缓存时间',
    deleteToRecycle: '删除到回收站',
    securityPath: '安全入口路径',
    path: '路径',
    backupConfig: '备份配置',
    backupAllConfig: '备份所有配置',
    backupCfgConfig: '备份Cfg配置',
    otherOperations: '其他操作',
    restartSoftware: '重启软件',
    homepage: '首页',
    userConfig: '用户配置',
    fileList: '文件列表',
    portMapping: '端口映射',
    tunnelMgmt: '隧道管理',
    dnsMgmt: 'DNS管理',
    userManagement: '用户管理',
    fileMgmt: '文件管理',
    editLoginRedirectPage: '编辑登录跳转页面',
    editWebSettings: '编辑网页设置',
    editNoPasswordLogin: '编辑无密码登录',
    browse: '浏览',
    noPasswordLoginStatus: '无密码登录状态',
    editCacheSettings: '编辑缓存设置',
    editSecurityPath: '编辑安全路径',
    editLogSettings: '编辑日志设置',
    close: '关闭',
  },
  transferServer: {
    title: '中转服务器设置',
    localAsTransferServer: '本地作为中转服务器设置',
    asClientHint: '作为映射客户端，无需启用服务，只需从以下服务器列表中选择。',
    asServerHint: '作为映射服务器，私有模式仅允许密钥匹配，公共模式允许所有设备',
    publicModeWarning: '公共模式需要端口转发，您也可以在设置中设置端口范围',
    name: '名称',
    attribute: '属性',
    address: '地址',
    port: '端口',
    key: '密钥',
    secondAuth: '二次认证',
    maxConnections: '最大连接数',
    mode: '模式',
    remark: '备注',
    operation: '操作',
    editConfig: '编辑配置',
    none: '无',
    availableServers: '可用的中转服务器',
    selectHint: '为端口映射和P2P映射选择。',
    forceCancelSelect: '强制取消选择',
    viewLogs: '查看日志',
    loading: '加载中...',
    noData: '暂无数据',
    newPort: '新端口',
    p2pService: 'P2P服务',
    connectionsTotal: '连接数/总数',
    notEnabled: '未启用',
    select: '选择',
    deselect: '取消选择',
    client: '客户端',
    server: '服务器',
    private: '私有',
    public: '公共',
  },
  distributionServer: {
    title: '分发服务器设置',
    connectionServerSettings: '连接分发服务器设置',
    viewLogs: '查看日志',
    address: '地址',
    port: '端口',
    key: '密钥',
    status: '状态',
    operation: '操作',
    edit: '编辑',
    enabled: '已启用',
    disabled: '已禁用',
    start: '启动',
    stop: '停止',
    running: '运行中',
    stopped: '已停止',
    restoreDefaults: '恢复默认',
    confirmStart: '确认启动连接服务器？',
    confirmStop: '确认停止连接服务器？',
    confirmRestore: '确认恢复默认设置？',
    distributionServerSettings: '分发服务器设置',
    confirmStartDistribution: '确认启动分发服务器？',
    confirmStopDistribution: '确认停止分发服务器？',
    portMappingSettings: '端口映射设置',
    portMappingHint: '当映射端口设置为0时，端口按以下规则自动分配',
    validPortRange: '有效端口范围',
    autoAssignStartPort: '自动分配起始端口',
    editConnectionSettings: '编辑连接服务器设置',
    editDistributionSettings: '编辑分发服务器设置',
    editPortMappingSettings: '编辑端口映射设置',
  },
  officialClient: {
    title: '控制服务器设置',
    serverSettings: '服务器设置',
    viewLogs: '查看日志',
    serverAddress: '服务器地址',
    serverPort: '服务器端口',
    associatedUser: '关联用户',
    status: '状态',
    operation: '操作',
    edit: '编辑',
    start: '启动',
    stop: '停止',
    running: '运行中',
    stopped: '已停止',
    autoAssigned: '自动分配',
    mappingName: '名称',
    internalAddress: '内部地址',
    internalPort: '内部端口',
    mappingPort: '映射端口',
    protocol: '协议',
    retry: '重试',
    autoMappingList: '自动映射列表',
    addMapping: '添加映射',
    delete: '删除',
    enable: '启用',
    disable: '禁用',
    refresh: '刷新',
    noMapping: '无端口映射',
    editClientConfig: '编辑客户端配置',
    serverAddressNotEditable: '服务器地址不可编辑',
    serverPortNotEditable: '服务器端口不可编辑',
    controlTokenNotEditable: '控制令牌不可编辑',
    controlToken: '控制令牌',
    enterUsername: '请输入用户名',
    enterControlToken: '请输入控制令牌',
    addNewMapping: '添加映射',
    editMapping: '编辑映射',
    namePlaceholder: '5-15个字符',
    internalIpPlaceholder: '127.0.0.1',
    internalPortPlaceholder: '1-65535',
    mappingPortPlaceholder: '0表示自动分配',
    autoAssignPort: '0表示自动分配端口',
    cancel: '取消',
    confirm: '确认',
    runningLogs: '运行日志',
    totalLogs: '共{count}条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    close: '关闭',
    noLogs: '暂无日志',
    confirmStopMapping: '确定要停止映射"{name}"吗？',
    confirmStopClient: '确定要停止客户端连接吗？所有映射将断开。',
    warning: '警告',
    usernameEmpty: '关联用户名为空，是否继续？',
    confirmText: '确认',
    cancelText: '取消',
    usernameLabel: '关联用户',
    nameLabel: '名称',
    internalAddressLabel: '内部地址',
    internalPortLabel: '内部端口',
    mappingPortLabel: '映射端口',
    protocolLabel: '协议',
    tcp: 'TCP',
    udp: 'UDP',
    mappingSuccess: '映射成功(端口:{port})',
    connected: '已连接',
    notConnected: '未连接',
    clientStarted: '客户端已启动',
    clientStopped: '客户端已停止',
    mappingAdded: '映射已添加',
    mappingUpdated: '映射已更新',
    mappingStarted: '映射已启动',
    mappingStopped: '映射已停止',
    mappingSaveFailed: '保存映射失败',
    mappingStartFailed: '启动映射失败',
    mappingStopFailed: '停止映射失败',
    mappingDisabled: '禁用',
    fetchFailed: '获取数据失败',
    enterName: '请输入名称',
    nameLengthError: '名称必须为5-15个字符',
    enterInternalAddress: '请输入内部地址',
    internalIpFormatError: '内部IP地址格式不正确',
    enterInternalPort: '请输入内部端口',
    internalPortRangeError: '内部端口范围为1-65535',
    enterMappingPort: '请输入映射端口',
    mappingPortRangeError: '映射端口范围为0-65535',
    selectProtocol: '请选择协议',
    refreshDataFailed: '刷新数据失败',
    refreshFailed: '刷新失败',
    saveFailed: '保存失败',
    saveMappingFailed: '保存映射失败',
    startMappingFailed: '启动映射失败',
    started: '已启动',
    startFailed: '启动失败',
    prompt: '提示',
    stopMappingFailed: '停止映射失败',
    mappingStoppedMsg: '已停止',
    stopFailed: '停止失败',
    updateClientConfigFailed: '更新客户端配置失败',
    clientConfigUpdated: '客户端配置已更新',
    updateFailed: '更新失败',
    serverAddressRequired: '服务器地址必填',
    serverPortRangeError: '服务器端口范围为1-65535',
    controlTokenRequired: '控制令牌必填',
    confirmStartClient: '确定要启动客户端连接吗？',
    startClientFailed: '启动客户端失败',
    stopClientFailed: '停止客户端失败',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    fetchLogsFailed: '获取日志失败',
    fetchLogsError: '获取日志错误',
    confirmClearLogs: '确定要清空所有端口映射日志吗？',
    clearLogsFailed: '清空日志失败',
    logsCleared: '日志已清空',
    clearLogsError: '清空日志错误',
    noLogsToDownload: '没有可下载的日志',
    downloadSuccess: '日志下载成功，共{count}条',
    downloadFailed: '日志下载失败',
    downloadError: '下载日志错误',
  },
  log: {
    title: '日志',
    viewLogs: '查看日志',
    clearLogs: '清空日志',
    downloadLogs: '下载日志',
    downloadAllLogs: '下载所有日志',
    module: '模块',
    level: '级别',
    content: '内容',
    time: '时间',
    allLogs: '所有日志',
    logTotal: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '刷新间隔',
    second: '秒',
    logCleared: '日志已清空',
    logDownloadSuccess: '日志下载成功，共 {count} 条记录',
    noLogs: '暂无日志记录',
    confirmClear: '确定要清空所有日志吗？此操作不可撤销！',
    clearFailed: '清空日志失败',
    cleared: '已清空',
    autoRefreshEnabled: '自动刷新已启用',
    autoRefreshDisabled: '自动刷新已禁用',
    fetchFailed: '获取日志失败',
    downloadFailed: '下载日志失败',
    noLogsToDownload: '没有可下载的日志',
    networkError: '网络错误',
  },
  collectList: {
    title: '收藏夹',
    totalItems: '共 {count} 项收藏',
    filePath: '文件路径',
    collectTime: '收藏时间',
    fileSize: '文件大小',
    collector: '收藏者',
    actions: '操作',
    delete: '删除',
    folder: '文件夹',
    deleted: '已删除',
    collectTimeLabel: '收藏时间:',
    fileSizeLabel: '文件大小:',
    collectorLabel: '收藏者:',
    fetchFailed: '获取收藏列表失败',
    pleaseLoginFirst: '请先登录系统',
    objectDeleted: '对象已删除',
    confirmDelete: '确定要删除收藏 "{path}" 吗？',
    confirm: '确认',
    cancel: '取消',
    deleteFailed: '删除收藏失败',
    deleteSuccess: '删除成功',
  },
  serverMapping: {
    title: '映射服务器',
    pleaseSelectTransferServer: '请选择中转服务器',
    description: '端口映射是将内网主机端口映射到外网端口。当用户访问外网端口时，将自动将请求转为访问对应内网主机端口服务。',
    mappingList: '端口映射列表',
    confirm: '确认',
    deleteConfirm: '确定要删除映射"{name}"吗？',
    cancelText: '取消',
    viewLogs: '查看日志',
    add: '新增',
    stopAll: '停止所有',
    restartAll: '重启所有',
    refresh: '刷新',
    loading: '加载中...',
    noMappingConfig: '暂无端口映射配置',
    name: '名称',
    internalAddress: '内网地址',
    internalPort: '内网端口号',
    mappingPort: '映射端口号',
    status: '状态',
    operation: '操作',
    edit: '编辑',
    start: '启动',
    stop: '停止',
    delete: '删除',
    editMapping: '编辑端口映射',
    addMapping: '新增端口映射',
    namePlaceholder: '3-15个字符，只能是数字或字母',
    internalIpPlaceholder: '例如: 127.0.0.1',
    internalPortPlaceholder: '1-65535',
    mappingPortPlaceholder: '0-65535',
    cancel: '取消',
    save: '保存',
    runningLogs: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
    nameRequired: '请输入名称',
    nameFormatError: '名称必须为3-15个字符，只能是数字或字母',
    ipRequired: '请输入内网IP地址',
    ipFormatError: '请输入有效的IP地址',
    internalPortRequired: '请输入内网端口号',
    internalPortRangeError: '端口号范围1-65535',
    mappingPortRequired: '请输入映射端口号',
    mappingPortRangeError: '端口号范围0-65535',
    pleaseSelectServer: '请先选择服务器',
    operationFailed: '操作失败',
    stopAllFailed: '停止所有失败',
    stopAllSuccess: '已停止所有映射',
    restartAllFailed: '重启所有失败',
    restartAllSuccess: '已重启所有映射',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    fetchLogsFailed: '获取日志失败',
    fetchLogsError: '获取日志失败',
    confirmClearLogs: '确定要清空所有端口映射日志吗？',
    clearLogsFailed: '清空日志失败',
    logsCleared: '日志已清空',
    noLogsToDownload: '没有可下载的日志',
    downloadSuccess: '日志下载成功，共 {count} 条',
    downloadFailed: '下载日志失败',
    pleaseLoginFirst: '请先登录',
  },
  p2pSetting: {
    title: 'P2P客户端设置(需重启软件生效)',
    viewLogs: '查看日志',
    currentCount: '当前数量',
    maxCount: '最大数量',
    operation: '操作',
    update: '更新',
    p2pServerSettings: 'P2P服务器设置',
    port: '端口号',
    enableRelay: '开启中转',
    status: '状态',
    running: '运行中',
    stopped: '已停止',
    stop: '停止',
    viewConnections: '查看连接',
    updateAndStart: '更新&启动',
    runningLogs: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
    fetchConfigFailed: '获取配置失败',
    countRequired: '数量不能为空',
    countRangeError: '取值范围是1-1000',
    updateFailed: '更新失败',
    updateSuccess: '更新成功，是否重启软件?',
    portRequired: '端口号不能为空',
    portRangeError: '端口取值范围是1-65535',
    selectRelayStatus: '请选择中转状态',
    restartSoftware: '重启软件',
    restartSoftwareFailed: '重启软件失败',
    softwareWillRestart: '软件将在3秒后重启',
    connectionLost: '当前连接断开，请刷新页面',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    networkError: '网络请求失败',
    fetchLogsFailed: '获取日志失败',
    fetchLogsError: '获取日志失败',
    confirmClearLogs: '确定要清空所有P2P日志吗？',
    clearLogsFailed: '清空日志失败',
    logsCleared: '日志已清空',
    noLogsToDownload: '没有可下载的日志',
    downloadSuccess: '所有日志下载成功，共 {count} 条记录',
    downloadFailed: '下载日志失败',
    pleaseLoginFirst: '请先登录系统',
  },
  proxyMgmt: {
    title: '正向代理服务器',
    viewLogs: '查看日志',
    description: '正向代理是客户端（如用户浏览器）与互联网之间的中间服务器。代表客户端向外部服务器发送请求，服务端不知道实际发起请求的客户端。',
    socks5Proxy: 'SOCKS5代理',
    httpsProxy: 'HTTPS代理',
    editConfig: '编辑配置',
    ipAddress: 'IP地址',
    port: '端口号',
    username: '用户名',
    password: '密码',
    status: '状态',
    operation: '操作',
    stop: '停止',
    start: '启动',
    noAuth: '无认证',
    noPassword: '无密码',
    notRunning: '未运行',
    running: '运行中',
    stopped: '已停止',
    error: '错误',
    notConnected: '未连接',
    success: '成功',
    editProxyConfig: '编辑{type}代理配置',
    ipPlaceholder: '例如: 0.0.0.0',
    portPlaceholder: '1-65535',
    usernamePlaceholder: '留空表示不需要认证',
    passwordPlaceholder: '留空表示不需要认证',
    cancel: '取消',
    save: '保存',
    runningLogs: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
    ipRequired: '请输入IP地址',
    ipFormatError: '请输入有效的IP地址',
    portRequired: '请输入端口号',
    portRangeError: '端口号范围1-65535',
    usernameFormatError: '用户名0-15个字符，只能是数字或字母',
    passwordFormatError: '密码0-64个字符，只能是数字或字母',
    confirmDiscard: '确定要放弃修改吗?',
    confirm: '确认',
    cancelText: '取消',
    operationFailed: '操作失败',
    configUpdateSuccess: '配置更新成功',
    configUpdateFailed: '配置更新失败',
    startSuccess: '启动成功',
    stopSuccess: '停止成功',
    startFailed: '启动失败',
    stopFailed: '停止失败',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    networkError: '网络请求失败',
    fetchLogsFailed: '获取日志失败',
    fetchLogsError: '获取日志失败',
    confirmClearLogs: '确定要清空所有代理日志吗？',
    clearLogsFailed: '清空日志失败',
    logsCleared: '日志已清空',
    noLogsToDownload: '没有可下载的日志',
    downloadSuccess: '日志下载成功，共 {count} 条',
    downloadFailed: '下载日志失败',
    pleaseLoginFirst: '请先登录系统',
  },
  reverseProxy: {
    title: '反向代理服务器',
    description: '反向代理是将外部请求转发（支持IPv4和IPv6）到内部服务器的特定端口。代理服务端，客户端不知道实际提供服务的服务端。',
    proxyList: '反向代理列表',
    viewLogs: '查看日志',
    add: '新增',
    refresh: '刷新',
    loading: '加载中...',
    noProxyConfig: '暂无反向代理配置',
    name: '名称',
    internalAddress: '内网地址',
    internalPort: '内网端口',
    mappingPort: '映射端口',
    protocol: '协议',
    status: '状态',
    operation: '操作',
    stop: '停止',
    start: '启动',
    edit: '编辑',
    delete: '删除',
    addProxy: '新增反向代理',
    editProxy: '编辑反向代理',
    namePlaceholder: '3-15个字符，只能是数字或字母',
    internalIpPlaceholder: '例如: 127.0.0.1',
    internalPortPlaceholder: '1-65535',
    mappingPortPlaceholder: '0-65535',
    cancel: '取消',
    save: '保存',
    runningLogs: '运行日志',
    totalLogs: '共 {count} 条日志',
    autoRefresh: '自动刷新',
    refreshInterval: '(5秒)',
    downloadAllLogs: '下载所有日志',
    refreshNow: '立即刷新',
    clearLogs: '清空日志',
    noLogs: '暂无日志记录',
    close: '关闭',
    nameRequired: '请输入名称',
    nameFormatError: '名称3-15个字符，只能是数字或字母',
    ipRequired: '请输入内网IP地址',
    ipFormatError: '请输入有效的IP地址',
    internalPortRequired: '请输入内网端口号',
    internalPortRangeError: '端口号范围1-65535',
    mappingPortRequired: '请输入映射端口号',
    mappingPortRangeError: '端口号范围0-65535',
    protocolRequired: '请选择协议',
    pleaseStopFirst: '请先停止该代理再进行编辑',
    confirmDiscard: '确定要放弃修改吗?',
    confirm: '确认',
    cancelText: '取消',
    operationFailed: '操作失败',
    operationSuccess: '操作成功',
    startSuccess: '启动成功',
    startFailed: '启动失败',
    stopSuccess: '停止成功',
    stopFailed: '停止失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteConfirm: '确定要删除该代理吗?',
    autoRefreshEnabled: '自动刷新已启用(5秒/次)',
    autoRefreshDisabled: '自动刷新已禁用',
    networkError: '网络请求失败',
    fetchLogsFailed: '获取日志失败',
    fetchLogsError: '获取日志失败',
    confirmClearLogs: '确定要清空所有反向代理日志吗？',
    clearLogsFailed: '清空日志失败',
    logsCleared: '日志已清空',
    noLogsToDownload: '没有可下载的日志',
    downloadSuccess: '日志下载成功，共 {count} 条',
    downloadFailed: '下载日志失败',
    pleaseLoginFirst: '请先登录系统',
    fetchDataFailed: '获取数据失败',
  },
  about: {
    title: '关于',
    productName: '产品名称',
    version: '版本',
    description: '描述',
    officialWebsite: '官方网站',
    documentation: '文档',
    support: '支持',
    license: '许可证',
    copyright: '版权所有',
    basicInfo: '基本信息',
    userManual: '用户手册',
    appManual: 'APP手册',
    csdnBlog: 'CSDN博客',
    bilibiliVideo: 'B站视频',
    versionAddress: '版本地址',
    officialDownload: '官方下载',
    weiyunDownload: '微云下载',
    otherAccess: '其他访问方式',
    contactEmail: '联系邮箱',
    qqGroup: 'QQ群',
    officialWebsite2: '官方网站',
    clickToView: '点击查看',
    featureInfo: '功能信息',
    passwordReset: '密码重置',
    disclaimer: '免责声明',
    updateLog: '更新日志',
    osLabel: '操作系统',
    unknown: '未知',
    ipv6HttpAddress: 'IPv6 HTTP地址',
    ipv6HttpsAddress: 'IPv6 HTTPS地址',
    enabled: '已启用',
    notEnabled: '未启用',
    notDetected: '未检测到IPv6地址',
    httpServiceNotEnabled: 'HTTP服务未启用',
    httpsServiceNotEnabled: 'HTTPS服务未启用',
    visit: '访问',
    copy: '复制',
    close: '关闭',
    fetchSystemInfoFailed: '获取系统信息失败',
    networkError: '网络错误，请检查连接',
    noContentToCopy: '没有可复制的内容',
    copySuccess: '复制成功',
    invalidUrl: '无效的URL',
    feature1: '支持用户登录(用户名:admin,默认密码:tf12345678),127.0.0.1本地访问将跳过密码',
    feature2: '支持Webdav(/tfdav)文件管理(HTTPS和HTTP),随时随地共享本地文件',
    feature3: '支持挂载Windows本地webdav服务,像访问C盘一样访问远程挂载的驱动器',
    feature4: '支持浏览器本地文件管理(HTTPS和HTTP),支持在线预览常见文件、视频、文档和PDF',
    feature5: '支持文件分享管理(有到期、密码和上传限制)',
    feature6: '支持公网(如阿里云、本地出口IP)端口映射',
    feature7: '支持P2P端口映射(基于TCP协议)',
    feature8: '支持HTTP代理和SOCKS5代理(用户名密码可选)',
    feature9: '支持将本地文件或文件夹同步到另一个tfcenter设备',
    feature10: '支持阿里云和派博(3322)DDNS',
    feature11: '支持tfcenter APP访问服务器(照片同步、视频播放、分享到微信和QQ等)',
    feature12: '支持CentOS 7/8、Ubuntu 18/20/22、Windows 10/11、ARM系统、树莓派等',
    feature13: '支持中英文界面切换',
    feature14: '支持SMB服务端文件共享',
    passwordResetLinux: 'Linux:使用-reset admin参数重置admin密码为tf12345678',
    passwordResetWindows: 'Windows:修改tfcenter.cfg的loAuthLogin参数为true以启用本地无密码登录',
    disclaimer1: '本软件免费使用。',
    disclaimer2: '本软件完全无害,不含任何恶意代码,但不保证任何第三方修改版本。',
    disclaimer3: '本软件不收集用户隐私数据。',
    log420item1: '新增模块管理,可禁用和启用模块网页显示',
    log420item2: '修复中转服务器域名配置错误问题',
    log420item3: '修复Cloudflare DDNS 无前缀错误请求问题',
    log420item4: '新增中英文切换功能',
    log420item5: '新增SMB服务端功能',
    log420item6: '当前版本不支持Windows 7等系统,如有需要请使用v4.1及之前的版本',
    log411item1: '支持修改web证书路径(证书文件名为cert.pem和priv.key)',
    log411item2: '支持ACME自动申请证书(支持阿里云自动申请),存储在当前certs目录',
    log411item3: '支持通过设置修改webdav后缀(默认是tfdav)',
    log411item4: '每个页面添加查看日志功能',
    log411item5: '修复分享时过期错误',
    log411item6: '修复设备中心设备删除失败',
    log411item7: '修复文件搜索时状态显示错误',
    log410item1: '优化手机显示同步管理',
    log410item2: '添加设备中心管理,可管理其他tfcenter设备地址',
    log403item1: '添加macOS支持',
    log403item2: '添加手动目录输入用于目录选择',
    log403item3: '修复Windows多选根目录C盘D盘错误',
    log402item1: '将左右和顶部导航改为可拖动模式,避免遮挡按钮',
    log402item2: '修复阿里云DDNS不支持无和*前缀',
    log402item3: '修复挂载页面PID匹配问题',
    log402item4: '禁用普通用户访问首页资源信息',
    log401item1: '修改Windows控制台,添加前台界面显示操作按钮及对应启动信息',
    log401item2: '修复一些显示问题',
    log400item1: '调整页面样式',
    log400item2: '添加反向代理功能',
    log400item3: '添加配置文件存储在BoltDB数据库',
    log400item4: '添加设置指定登录跳转页面',
    log400item5: '添加自动登录功能',
    log400item6: '内置Windows Webdav服务挂载',
    log400item7: '添加控制服务器功能',
    log400item8: '添加其他访问方式(在关于中查看)',
    log342item1: '取消Windows守护进程启动,避免某些操作系统产生过多进程',
    log342item2: '更新tfcenter-daemon.bat脚本,设置服务退出时自动重启',
    log341item1: '实现程序守护进程启动,移除Windows和Linux tfcenter-daemon程序',
    log341item2: '端口映射服务器异常退出:客户端重连一次->保持重连',
    log341item3: '添加映射服务器断开后自动重连',
    log341item4: '修复文件管理下载时大小显示错误',
  },
}
